export var BasicLayoutVariant;
(function (BasicLayoutVariant) {
    BasicLayoutVariant["DETAILED"] = "DETAILED";
    BasicLayoutVariant["COMPACT"] = "COMPACT";
})(BasicLayoutVariant || (BasicLayoutVariant = {}));
export { default as FullOffer } from './FullOffer';
